import React from "react";
import RequestOperationalModuleListTab from "../../../styles/RequestOperationalModuleListTab";

function CustomTab({ data }) {

    //** State's */
    // const [visibleTab, setVisibleTab] = React.useState(data.filter((tab) => tab.isVisible === true)[0]?.id || null);
    const [visibleTab, setVisibleTab] = React.useState(data[0]?.id || null);

    // //** Title's */
    // const listTitles = data.filter((tab) => tab.isVisible === true).map((item) => (
    //     <li key={item.id} onClick={() => setVisibleTab(item.id)}
    //         className={visibleTab === item.id ? "tab-title tab-title--active btn-hover-1 color-3 active" : "btn-hover-1 color-3 tab-title"}>
    //         {item.tabTitle}
    //     </li>
    // ));

    //** Title's */
    const listTitles = data.map((item) => (
        <li key={item.id} onClick={() => setVisibleTab(item.id)}
            className={visibleTab === item.id ? "tab-title tab-title--active btn-hover-1 color-3 active" : "btn-hover-1 color-3 tab-title"}>
            {item.tabTitle}
        </li>
    ));

    return (
        <React.Fragment>
            <RequestOperationalModuleListTab />
            {listTitles.length > 0 &&
                <div className="tabs new-btn-width scroll_content_logs">
                    <ul className="tabs-titles justify-content-left new-border pl-0">
                        {listTitles}
                    </ul>
                    <div className="tab-content mt-2">
                        {/* {data.filter((tab) => tab.isVisible === true).map((item) => visibleTab === item.id ? <p style={{}}>{item.tabContent}</p> : null)} */}
                        {data.map((item) => visibleTab === item.id ? <p style={{}}>{item.tabContent}</p> : null)}
                    </div>
                </div>
            }
        </React.Fragment>
    );
}

export default CustomTab;
